import { OnInit } from "@angular/core";
import { Language } from "../services/language.service";
import { Localized } from "../../../objects";

export class EditEntityBaseClass implements OnInit {

  public currentLanguageCode = "eng";
  public currentLanguage: Language;
  public currentLocalizedData: Localized;
  public listsLoaded = true;
  public item: any;


  ngOnInit() {

    this.currentLocalizedData = null;
    if (this.item != null && this.item.Localized != null) {
      
      this.currentLocalizedData = this.item.Localized[0];
    }

  }

  public CurrentLocalizedData(): Localized {

    if (this.currentLanguage == null) { return null; }

    var result = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });
    if (result.length === 1) {
     // console.log("LocalizedData Found", result[0]);
      return result[0];
    }

    return null;
  }

  private addLocalizationIfNeeded() {

    if (this.currentLanguage == null) { return; };
    if (this.item == null) { return; }
    if (this.item.Localized == null) {
      this.initLocalization();
    }

    var localizedData = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });

    // console.log("addLocalizationIfNeeded", localizedData, this.currentLanguage.Code);

    if (localizedData.length === 0) {
      this.initLocalization();
    }

  }

  private initLocalization() {
    // console.log("adding new localization");
    if (this.item.Localized == null) {
      this.item.Localized = new Array<Localized>();
    }
     var newData = new Localized();
     newData.LanguageCode = this.currentLanguage.Code;
     this.item.Localized.push(newData);
  }

  public setSelectedLanguage(language: Language) {

    console.log("setSelectedLangage", language);
    this.currentLanguage = language;

    this.addLocalizationIfNeeded();

  }

  public setModelValue(value: any, target: any) {

    console.group("setModelValue");
    console.log("value", value);
    console.log("target", target);

    if (target == null) {
      target = {
        Id: value
      };
    } else {
      target.Id = value;
      if (target.Id == "") {
        target = null;
      }
    }
    console.log("setModelValue AFTER",  target);
    console.groupEnd();
    

    return target;

  }


  public setModelValueOfCollection(value: any, target: any, collection: any[]) {

    console.group("setModelValue");
    console.log("value", value);
    console.log("target", target);
    console.log("collection", collection);
 
    var match = collection.find(element => element.Id == value);
    target =  match;

    console.log("setModelValue AFTER",  target);
    console.groupEnd();
    

    return target;

  }
}

